export default "__VITE_ASSET__BmnkPN9n__"